import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BasemodelService } from 'src/app/basemodel.service';

@Injectable({
  providedIn: 'root'
})
export class AttendanceService {
  roles: any = [];
  EXCEL_EXTENSION = '.xlsx';
  EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';


  private jwtToken="";
  Commonurl: any = '';
  AttendanceUrl: any ='';
  constructor(public http: HttpClient,  public basemodelService:BasemodelService) { 
  }

  private bearer="a6a83a30-b51d-4bea-8af3-ac4a5cdae54c"
  private state=this.basemodelService.getCommonUrl() +"/apiV2/common/employeeStates"
  private city=this.basemodelService.getCommonUrl() +"/apiV2/common/emplStateCities?stateId="
  private campus=this.basemodelService.getCommonUrl() +"/apiV2/common/empCityCampuses?cityId="
  private buildings=this.basemodelService.getCommonUrl() +"/apiV2/common/empCmpBuilding?campusId="
  private Attendence=this.basemodelService.getAttendanceUrl() +"/employee/api/jwtV2/attendanceOfTodayAndYesterday?filterBy="
  private class=this.basemodelService.getCommonUrl() +"/apiV2/common/buildingClasses?buildingId="
  private stream=this.basemodelService.getCommonUrl() +"/apiV2/common/classStreams?buildingId="
  private classid="&classId="
  private section=this.basemodelService.getCommonUrl() +"/apiV2/common/programWiseSections?buildingId="
  private streamid="&streamId="
  private program=this.basemodelService.getCommonUrl() +"/apiV2/common/streamPrograms?buildingId="
  private sectionid="&sectionId="
  private examprogram=this.basemodelService.getCommonUrl()+"/apiV2/common/programExamPrograms?programId="
  private programid="&programId="
  private Filter=this.basemodelService.getAttendanceUrl() +"/employee/api/jwtV2/attendanceOfTodayAndYesterday?filterBy="
  private weekFilter=this.basemodelService.getAttendanceUrl() +"/employee/api/jwtV2/attendenceByFilter?filterBy="
   private betweendates=this.basemodelService.getAttendanceUrl() +"/employee/api/jwtV2/getDataBetweenDates?startDate="
  private examProgramId="&examProgramId="
  private building="&buildingId="
  private data={
    "payrollId":"HYD103135",
    "mobileNo":"0",
    "subject":"StudentAttendance"
    }

    getattendance(){
      const headers = new HttpHeaders({
        'Authorization': ` ${ this.jwtToken}`
      });
      return this.http.get(environment.AttendanceUrl+"/api/studentWeeklyAttendanceSummary",{headers});
    }

    // getweekAttendances(filterBy:any){
    //   const headers= new HttpHeaders({
    //     'Authorization': this.jwtToken,
    //   });
    //   return this.http.get(this.weekFilter+filterBy,{headers})
    // }
    getweekAttendances(filterBy:any): Observable<any[]>{
      const headers= new HttpHeaders({
        'Authorization': this.jwtToken,
      });
      return this.http.get<any[]>(this.weekFilter+filterBy,{headers})
    }
  getState()
  {
    const headers= new HttpHeaders({
      'Authorization': this.jwtToken,
    });
    return this.http.get(this.state,{headers})
  }
  getCity(stateId:any)
  {
    const headers= new HttpHeaders({
      'Authorization': this.jwtToken,
    });
    return this.http.get(this.city+stateId,{headers})
  }
  getCampus(cityId:any)
  {
    const headers= new HttpHeaders({
      'Authorization': this.jwtToken,
    });
    return this.http.get(this.campus+cityId,{headers})
  }
  getbuildings(campusId:any)
  {
    const headers= new HttpHeaders({
      'Authorization': this.jwtToken,
    });
    return this.http.get(this.buildings+campusId,{headers})
  }
  getAttendence(filterBy:any)
  {
    const headers= new HttpHeaders({
      'Authorization': this.jwtToken,
    });
    return this.http.get(this.Attendence+filterBy,{headers})
  }
  getClass(buildingId:any){
    const headers = { 'Authorization': `Bearer ${this.bearer}` };
    return this.http.get(this.class+buildingId, { headers });
  }
  getStream(buildingId:any,classid:any){
    const headers = { 'Authorization': `Bearer ${this.bearer}` };
    return this.http.get(this.stream+buildingId+this.classid+classid, { headers });
  }
  getProgram(buildingId:any,classid:any,streamid:any){
    const headers = { 'Authorization': `Bearer ${this.bearer}` };
    return this.http.get(this.program+buildingId+this.classid+classid+this.streamid+streamid, { headers });
  }
  getSection(buildingId:any,classid:any,streamid:any,programid:any){
    const headers = { 'Authorization': `Bearer ${this.bearer}` };
    return this.http.get(this.section+buildingId+this.classid+classid+this.streamid+streamid+this.programid+programid, { headers });
  }
 
  getExamProgram(programid:any){
    const headers = { 'Authorization': `Bearer ${this.bearer}` };
    return this.http.get(this.examprogram+programid, { headers });
  }
  getFilterList(filterBy:any,buildingId:any,classid:any,streamid:any,sectionId:any,programid:any,examProgramId:any)
  {
    const headers= new HttpHeaders({
      'Authorization': this.jwtToken,
    });
    return this.http.get(this.Filter+filterBy+this.building+buildingId+this.classid+classid+this.streamid+streamid+this.sectionid+sectionId+this.programid+programid+this.examProgramId+examProgramId, { headers })
  }
  getWeekFilterList(filterBy:any,buildingId:any,classid:any,streamid:any,sectionId:any,programid:any,examProgramId:any): Observable<any[]>
  {
    const headers= new HttpHeaders({
      'Authorization': this.jwtToken,
    });
    return this.http.get<any[]>(this.weekFilter+filterBy+this.building+buildingId+this.classid+classid+this.streamid+streamid+this.sectionid+sectionId+this.programid+programid+this.examProgramId+examProgramId, { headers })
  }
  getbetweendatesList(startDate:any,endDate:any,buildingId:any,classid:any,streamid:any,sectionId:any,programid:any,examProgramId:any): Observable<any[]>{
    const headers= new HttpHeaders({
      'Authorization': this.jwtToken,
    });
    return this.http.get<any[]>(this.betweendates+startDate+"&endDate="+endDate+this.building+buildingId+this.classid+classid+this.streamid+streamid+this.sectionid+sectionId+this.programid+programid+this.examProgramId+examProgramId, { headers })
  }
  getWeekList(filter:any){
    const headers= new HttpHeaders({
      'Authorization': this.jwtToken,
    });
    return this.http.get(this.weekFilter+filter, { headers })
  }

  getdefultstate(){
    const headers=new HttpHeaders({
     'Authorization': this.jwtToken,
    })
    return this.http.get(this.basemodelService.getCommonUrl()+"/employee/api/jwtV2/student/weeklyAttendance/empCampuses",{headers})
     }
     getfilterlist(url:any,name:any){
       const headers=new HttpHeaders({
         'Authorization': this.jwtToken,
        })
        return this.http.get(url+name,{headers})
     }
     getattendancesdymaic(url:any):Observable<any[]>{
       const headers=new HttpHeaders({
         'Authorization': this.jwtToken,
        })
        return this.http.get<any[]>(this.basemodelService.getAttendanceUrl()+"/employee/api/jwtV2/attendenceByFilterV2?"+url,{headers})
     }
     getattendancestodayandyesterday(url:any){
       const headers=new HttpHeaders({
         'Authorization': this.jwtToken,
        })
        return  this.http.get(this.basemodelService.getAttendanceUrl()+"/employee/api/jwtV2/attendanceOfTodayAndYesterdayV2?"+url,{headers})
     }
     getbetweendates(url:any):Observable<any[]>{
       const headers=new HttpHeaders({
         'Authorization': this.jwtToken,
        })
        return this.http.get<any[]>(this.basemodelService.getAttendanceUrl()+"/employee/api/jwtV2/getDataBetweenDatesV2?"+url,{headers})
     }
     getselecteddate(url:any){
       const headers=new HttpHeaders({
         'Authorization': this.jwtToken,
        })
        return this.http.get(this.basemodelService.getAttendanceUrl()+"/employee/api/jwtV2/attendanceOfSelectedDate?"+url,{headers})
     }



  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: this.EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() +this.EXCEL_EXTENSION);
  }
}
